import { safeParse } from 'valibot';
import { getAnalyticsSdk, initAdobeDataLayerAsync } from './init';
import { FUNNEL_STEP } from './xdm.constants';
import { BusXDMBaseSchema } from './xdm.schema';

// Namespace import to avoid depending on exact named exports at build time.
import * as GtEventLoggerWeb from '@gt-common/event-logger-web';

type LogPageLoadArgs = {
  event: unknown;
  funnelStep?: (typeof FUNNEL_STEP)[keyof typeof FUNNEL_STEP];
  schema?: unknown;
};

export const logPageLoadEventToXDM = async ({
  event,
}: LogPageLoadArgs): Promise<boolean> => {
  try {
    if (typeof window === 'undefined') return false;
    // Default disabled everywhere: only allow logging when explicitly enabled for this session.
    if (sessionStorage.getItem('enable_xdm_logging|') !== 'true') return false;

    // Ensure vendor script has had a chance to load before logging.
    const ready = await initAdobeDataLayerAsync(5000);
    if (!ready) {
      return false;
    }

    // `schema` is runtime-provided; keep it flexible and validate best-effort.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parsed = safeParse(BusXDMBaseSchema as any, event);
    if (!parsed.success) {
      // Don’t break page if schema fails.
      return false;
    }

    // Best effort init
    getAnalyticsSdk();

    const XDMWrapper = (GtEventLoggerWeb as Record<string, unknown>)
      ?.XDMWrapper as
      | undefined
      | {
          logEvent?: (args: Record<string, unknown>) => Promise<unknown>;
        };
    if (!XDMWrapper?.logEvent) {
      return false;
    }

    const GT_LOBS = (GtEventLoggerWeb as Record<string, unknown>)?.GT_LOBS as
      | undefined
      | Record<string, unknown>;
    const TARGETS = (GtEventLoggerWeb as Record<string, unknown>)?.TARGETS as
      | undefined
      | Record<string, unknown>;

    const lob = (GT_LOBS?.BUS as string | undefined) || 'BUS';
    const target = (TARGETS?.ALL as string | undefined) || 'ALL';

    await XDMWrapper.logEvent({
      payload: event,
      schema: BusXDMBaseSchema,
      otherConfig: { lobName: lob, adobeKeyConfig: [] },
      target,
      extraOptions: { lob, destinationUrl: window.location.href },
    });

    return true;
  } catch (e) {
    return false;
  }
};
